import { render, staticRenderFns } from "./Datalevels.vue?vue&type=template&id=a2b2d266&scoped=true"
import script from "./Datalevels.vue?vue&type=script&lang=js"
export * from "./Datalevels.vue?vue&type=script&lang=js"
import style0 from "./Datalevels.vue?vue&type=style&index=0&id=a2b2d266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b2d266",
  null
  
)

export default component.exports